let zClient: any;

if (zClient === undefined) {
  // @ts-ignore
  const zaf: any = ZAFClient.init();
  if (zaf !== false) {
    let zUser: any;
    let ticketContext: any;
    (async () => {
      zUser = await zaf.get('currentUser');
      ticketContext = await zaf.context();
    })();

    zClient = {};

    const exec = <T, Fn extends (...args: any[]) => Promise<T>>(
      callback: Fn
    ) => {
      return async (...callbackArgs: Parameters<Fn>): Promise<T> => {
        try {
          return await callback(...callbackArgs);
        } catch (err: any) {
          const requestParams = JSON.parse(JSON.stringify(callbackArgs));
          // remove auth header
          requestParams.forEach(
            (param: { headers?: { Authorization?: string } }) => {
              if (param?.headers?.Authorization) {
                delete param?.headers?.Authorization;
              }
            }
          );
          throw {
            ...err,
            ticketId: ticketContext?.ticketId,
            userEmail: zUser?.currentUser?.email,
            requestParams: JSON.stringify(requestParams),
            originalError: err,
          };
        }
      };
    };

    // zClient.request
    zClient.request = exec((options: any): Promise<any> =>
      zaf.request(options)
    );

    // zClient.get
    zClient.get = exec((...args: any[]): Promise<any> => zaf.get(...args));

    // zClient.set
    zClient.set = exec((...args: any[]): Promise<any> => zaf.set(...args));

    // zClient.context
    zClient.context = exec((...args: any[]): Promise<any> =>
      zaf.context(...args)
    );

    // zClient.on
    zClient.on = exec((...args: any[]): Promise<any> => zaf.on(...args));

    // zClient.invoke
    zClient.invoke = exec((...args: any[]): Promise<any> =>
      zaf.invoke(...args)
    );
  }
}

export { zClient };
